/* src/app/views/collection/components/modals/collection-displays-modal-container/collection-displays-modal-container.component.scss */
.background-white {
  background-color: #fff;
}
/*# sourceMappingURL=collection-displays-modal-container.component.css.map */
